import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import S99au from "../pages/s99au/page";
import S99my from "../pages/s99my/page";
import Rec99au from "../pages/rec99au/page";
import Fc8au from "../pages/fc8au/page";
import Dd8au from "../pages/dd8au/page";
import Splinkos from "../pages/splinkos/page";
import Sboomerang from "../pages/sboomerang/page";
import Sbingo9 from "../pages/sbingo9/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/s99au",
    element: <S99au />,
  },
  {
    path: "/s99my",
    element: <S99my />,
  },
  {
    path: "/rec99au",
    element: <Rec99au />,
  },
  {
    path: "/fc8au",
    element: <Fc8au />,
  },
  {
    path: "/dd8au",
    element: <Dd8au />,
  },
  {
    path: "/splinkos",
    element: <Splinkos />,
  },
  {
    path: "/sboomerang",
    element: <Sboomerang />,
  },
  {
    path: "/sbingo9",
    element: <Sbingo9 />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
